/**
 * Hooks Index
 * Tüm custom hook'ların merkezi export noktası
 */

// ===== Ortak Hook'lar (Sales & Purchase için) =====
export { useInvoiceCalculations } from './useInvoiceCalculations';
export { useInvoiceItems } from './useInvoiceItems';
export { useAccountSelection } from './useAccountSelection';
export { useWarehouseManagement } from './useWarehouseManagement';
export { useDraftManagement } from './useDraftManagement';

// ===== Alış Faturası (Purchase Invoice) Hook'ları =====
export { usePurchaseInvoiceForm, unitOptions, getTodayLocal } from './usePurchaseInvoiceForm';
export { usePurchaseInvoiceData } from './usePurchaseInvoiceData';
export { usePurchaseInvoiceSave } from './usePurchaseInvoiceSave';
export { usePurchaseInvoiceDraft } from './usePurchaseInvoiceDraft';
export type { PurchaseInvoiceDraftData } from './usePurchaseInvoiceDraft';
export { usePurchaseInvoiceCalculations } from './usePurchaseInvoiceCalculations';

